import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsPutRes extends EntityStaff {}
